/* KRUX shop buttons — runs the same 2s shimmer as the homepage SHOP CAPS
   button on every .krux-buy button, only while it is on screen. Skipped for
   reduced-motion users. Visual styles: assets/krux-shop-buttons.css and the
   .krux-cta-shimmer rules in assets/krux-section-cues.css. */
(function () {
  'use strict';
  function init() {
    var targets = document.querySelectorAll('.krux-buy');
    if (!targets.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-shimmering'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('is-shimmering');
        else e.target.classList.remove('is-shimmering');
      });
    }, { threshold: 0.6 });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
